import React, { useEffect } from "react";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { StyledEngineProvider } from "@mui/material/styles";

import { App } from "./app/Index";
import configureStore from "./_redux/configureStore";
import { setNavigate } from "@/_helpers/navigation";
import "./i18n";
import "./styles.css";
import { MuiToasterProvider } from "./_components/toaster/MuiToasterProvider";


const store = configureStore();

function AppWithNavigateSetter() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return <App />;
}

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <MuiToasterProvider>
  <ReduxProvider store={store}>
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <AppWithNavigateSetter />
      </StyledEngineProvider>
    </BrowserRouter>
  </ReduxProvider>
  </MuiToasterProvider>
);
